import React from 'react';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';
import styles from './index.module.scss';
import { FormatDateString, ValueOnly, handleKeyPress } from './util';
import { DateFieldProps } from './interface';

const { yearWidth, spanDateInput } = styles;

export const YearFieldInput = (props: DateFieldProps) => {
    const { value, onChangeHandler, onBlur, id } = props;

    const activeId = document.activeElement === null ? 'unknown' : document.activeElement.id;

    const hasFocus = id === activeId;
    const displayValue = !value ? '' : hasFocus ? value : FormatDateString(value, 4);

    const onFocus = (event: React.FocusEvent<any>) => {
        event.currentTarget.value = ValueOnly(event.currentTarget.value);
        event.currentTarget.select();
    };

    return (
        <span className={spanDateInput} >
            <Label htmlFor={id} className='rdtiSubQuestion'>Year<span className='sr-only'>(YYYY)</span></Label>
            <Input
                id={id}
                className={yearWidth}
                type='text'
                autoComplete='off'
                onChange={onChangeHandler}
                value={displayValue} // turn 0 and undefined to ''
                onBlur={onBlur}
                onFocus={onFocus}
                onKeyPress={handleKeyPress}
                placeholder='YYYY'
            />
        </span>
    );
};
